export default "__VITE_ASSET__9bDGvAD8__";